import React from "react";

const FONT = "'Host Grotesk', sans-serif";

const OPTIONS = [
  { value: "keyword", label: "By Keyword" },
  { value: "user", label: "By User" },
];

const SourceDropdown = ({ activeSource, handleSourceClick }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      {OPTIONS.map(({ value, label }) => {
        const isSelected = activeSource === value;
        return (
          <label
            key={value}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              cursor: "pointer",
              fontFamily: FONT,
              fontSize: "12px",
              fontWeight: isSelected ? 600 : 500,
              color: isSelected ? "#0f172a" : "#64748b",
              transition: "color 0.15s ease",
            }}
          >
            <input
              type="radio"
              name="sourceType"
              value={value}
              checked={isSelected}
              onChange={() => handleSourceClick(value)}
              style={{
                accentColor: "#667eea",
                cursor: "pointer",
                width: 14,
                height: 14,
              }}
            />
            {label}
          </label>
        );
      })}
    </div>
  );
};

export default SourceDropdown;
